import PropTypes from 'prop-types';
import ToolTip, {tooltipPositions} from '../ToolTip.jsx';
import nextTick from '../../helpers/nextTick';
import classNames from 'classnames';

import React from 'react';

import EditableCheckbox from '../forms/editableCheckbox.jsx';

class LayoutCheckbox extends React.Component {
  static defaultProps = {
    condition: true,
    disabled: false,
    editMode: true,
    label: '',
  };

  static propTypes = {
    condition: PropTypes.bool,
    dataChanged: PropTypes.func,
    dataKey: PropTypes.any,
    disabled: PropTypes.any,
    editMode: PropTypes.bool,
    hideLabel: PropTypes.bool,
    inline: PropTypes.bool,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    topLabel: PropTypes.string,
    value: PropTypes.bool,
    className: PropTypes.string,
    tooltip: PropTypes.string,
    'data-event-action': PropTypes.string,
    'data-event-category': PropTypes.string,
  };

  state = {
    value: this.props.value,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value) {
      this.setState({
        value: nextProps.value,
      });
    }
  }

  onChange = (val) => {
    if (val.value !== this.state.value) {
      this.setState({
        value: val.value,
      });
    }

    nextTick(() => { // Let state update before callback
      if (this.props.dataChanged) {
        this.props.dataChanged({value: val.value, key: this.props.dataKey});
      }
    });
  };

  getChecked = () => {
    return this.state.value;
  };

  highlight = () => {
    return this.input.highlight();
  };

  render() {
    let disabled = this.props.disabled;

    if (disabled instanceof Array) {
      disabled = disabled.indexOf(this.props.dataKey) !== -1;
    }

    const classes = classNames(this.props.className, 'form-group', {'inline-checkbox': this.props.inline});

    if (this.props.condition) {
      return <div className={classes}>
        {this.props.topLabel ? <label>
          {this.props.topLabel}
          {this.props.tooltip ? <ToolTip title={this.props.tooltip} position={tooltipPositions.topRight} iconOnly /> : null}
        </label> : null}
        <EditableCheckbox
          dataKey={this.props.dataKey}
          disabled={disabled}
          editMode={this.props.editMode}
          hideLabel={this.props.hideLabel}
          label={this.props.label}
          ref={r => this.input = r}
          onChange={this.onChange}
          data-event-category={this.props['data-event-category']}
          data-event-action={this.props['data-event-action']}
          value={this.state.value}
        />
      </div>;
    }

    return null;
  }
}

export default LayoutCheckbox;
